export const routeMap = {
  DefaultPage: "/",
  ext_AboutUs: "/about",
  eAIN: "/howToApply",
  ext_Cookies: "/cookies",
  ext_ContactUs: "/contactUs",
  ext_FAQS: "/faq",
  ext_Disclaimer: "/disclaimer"
}
